import { useDropdownState } from '../abstract/dropdown';

export function useStatusFilter({
  config,
  query,
  setFilters,
  updateQuery,
}) {
  let { selected: status, onSelect: onStatusSelect, options: statusOptions } = useDropdownState({
    defaultOptions: config.statusOptions,
    defaultValue: query.status || config.statusDefault,
    filterKey: `statuses`,
    queryKey: `status`,
    setFilters,
    updateQuery,
    isNumeric: false,
  });

  return { status, statusOptions, onStatusSelect };
}

